import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("heda_token");
  if (token) {
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  // Showroom customer session token (set when staff starts a session for a customer).
  try {
    const raw = localStorage.getItem("heda_customer_session");
    if (raw) {
      const s = JSON.parse(raw);
      if (s?.session_id) cfg.headers["X-Customer-Session"] = s.session_id;
    }
  } catch {
    /* ignore */
  }
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Avoid loops — let calling code handle redirect
    }
    return Promise.reject(err);
  },
);

export const fileUrl = (storagePath) =>
  storagePath ? `${API}/files/${storagePath}` : "";

export default api;
